export default __webpack_public_path__ + "static/media/MiniSlide-2.374473a3.png";